<template>
  <div>
    <n-table-view
        ref="table"
        name="Список"
        class="table3"
        :genRequestBuilder="requestBuilder"
        :height="height"
        :headers="[
          { text: 'ID', value: 'id', class:'text-no-wrap'},
          { text: 'Тип', value: 'type', class:'text-no-wrap'},
          { text: 'Сортировка', value: 'sort', class:'text-no-wrap'},
          { text: 'Название', value: 'name', class:'text-no-wrap'},
          { text: 'Первичный', value: 'isSecond', class:'text-no-wrap'},
          { text: 'Взрослый', value: 'isAdult', class:'text-no-wrap'},
          { text: 'Специализации', value: 'specs.id', class:'text-no-wrap'},
          { text: 'Филиалы', value: 'comBranchs.id', class:'text-no-wrap'},
          { text: 'Текст', value: 'text', class:'text-no-wrap'},
        ]"
    >
      <template v-slot:barActions>
        <v-btn
          @click="createState.modalOpen({
            name:'',
            type:null,
            sort:100,
            isSecond:null,
            isAdult:null,
            specs:[],
            comBranchs:[],
          })"
          depressed small
        >
          Создать
        </v-btn>
      </template>
      <template v-slot:item="{ item }">
        <tr @click="updateState.modalOpen(item)">
          <td class="text-no-wrap">{{ item.id }}</td>
          <td class="text-no-wrap">
            <chip v-if="item.type==='visitConfirmed'">Визит подтвержден</chip>
          </td>
          <td class="text-no-wrap">{{item.sort}}</td>
          <td class="text-no-wrap">{{ item.name }}</td>
          <td class="text-no-wrap">
            <span v-if="item.isSecond===false">Да</span>
            <span v-else-if="item.isSecond===true">Нет</span>
          </td>
          <td class="text-no-wrap">
            <span v-if="item.isAdult===true">Да</span>
            <span v-else-if="item.isAdult===false">Нет</span>
          </td>
          <td class="text-no-wrap">{{item.specs.map(v=>v.name).join(',')}}</td>
          <td class="text-no-wrap">{{item.comBranchs.map(v=>v.name).join(',')}}</td>
          <td class="text-no-wrap">
            <tooltip-view>
              <template v-slot:action>
                <v-sheet color="transparent" max-width="800" class="text-overflow">{{item.text}}</v-sheet>
              </template>
              <template v-slot:content>
                <div v-html="$tools.nl2br(item.text)" class="body-2 mb-2"></div>
              </template>
            </tooltip-view>
          </td>
        </tr>
      </template>
    </n-table-view>
    <dialog-view
        :open="createState.modal"
        title="Создать триггер"
        @cancel="createState.modalClose()"
    >
      <template v-slot:content>
        <v-form ref="createForm" v-if="createState.data">
          <v-text-field label="Название" v-model="createState.data.name" :rules="formFieldRules.required" outlined dense hide-details="auto" class="mb-4" clearable/>
          <v-text-field label="Сортировка" v-model="createState.data.sort" :rules="formFieldRules.required" outlined dense hide-details="auto" class="mb-4" clearable/>
          <v-select
              label="Первичный"
              v-model="createState.data.isSecond"
              :items="[{name:'Не выбрано',value:null},{name:'Да',value:false},{name:'Нет',value:true}]"
              outlined dense hide-details="auto" class="mb-4" item-text="name"
          />
          <v-select
              label="Взрослый (>=18 лет)"
              v-model="createState.data.isAdult"
              :items="[{name:'Не выбрано',value:null},{name:'Да',value:true},{name:'Нет',value:false}]"
              outlined dense hide-details="auto" class="mb-4" item-text="name"
          />
          <spec-autocomplete-multiple :select.sync="createState.data.specs"/>
          <com-branch-autocomplete-multiple :select.sync="createState.data.comBranchs"/>
          <v-textarea label="Текст" v-model="createState.data.text" :rules="formFieldRules.required" outlined dense hide-details="auto" auto-grow class="mb-4" clearable/>
        </v-form>
      </template>
      <template v-slot:actions>
        <v-btn @click="$refs.createForm.validate() ? create() : null" :loading="createState.loadingUpdate" color="primary" text>Создать</v-btn>
      </template>
    </dialog-view>
    <dialog-view
        :open="updateState.modal"
        :title="'Изменить триггер '+(updateState.data ? '#'+updateState.data.id : '')"
        :loading="updateState.loading"
        @cancel="updateState.modalClose()"
    >
      <template v-slot:content>
        <v-form ref="updateForm" v-if="updateState.data">
          <v-text-field label="Название" v-model="updateState.data.name" :rules="formFieldRules.required" outlined dense hide-details="auto" class="mb-4" clearable/>
          <v-text-field label="Сортировка" v-model="updateState.data.sort" :rules="formFieldRules.required" outlined dense hide-details="auto" class="mb-4" clearable/>
          <v-select
              label="Первичный"
              v-model="updateState.data.isSecond"
              :items="[{name:'Не выбрано',value:null},{name:'Да',value:false},{name:'Нет',value:true}]"
              outlined dense hide-details="auto" class="mb-4" item-text="name"
          />
          <v-select
              label="Взрослый (>=18 лет)"
              v-model="updateState.data.isAdult"
              :items="[{name:'Не выбрано',value:null},{name:'Да',value:true},{name:'Нет',value:false}]"
              outlined dense hide-details="auto" class="mb-4" item-text="name"
          />
          <spec-autocomplete-multiple :select.sync="updateState.data.specs"/>
          <com-branch-autocomplete-multiple :select.sync="updateState.data.comBranchs"/>
          <v-textarea label="Текст" v-model="updateState.data.text" :rules="formFieldRules.required" outlined dense hide-details="auto" auto-grow class="mb-4" clearable/>
        </v-form>
      </template>
      <template v-slot:actions>
        <div v-if="updateState.data">
          <btn-text-accept name="Удалить" text="Удалить триггер?" color="error" @accept="del(updateState.data)" :loading="deleteState.loadingUpdate"/>
          <v-btn @click="$refs.updateForm.validate() ? update() : null" :loading="updateState.loadingUpdate" color="primary" text>Изменить</v-btn>
        </div>
      </template>
    </dialog-view>
  </div>
</template>

<script>

import {
  Entity_ComBranch,
  Entity_DialogMessageTrigger, Entity_Spec
} from "../../../../../EntityStoreCacheService";
import NTableView from "@/componentsV2/base/NTableView.vue";
import DialogView from "@/components/DialogView.vue";
import Stater from "@/plugins/stater";
import SpecAutocompleteMultiple from "@/componentsV2/custom/SpecAutocompleteMultiple.vue";
import ComBranchAutocompleteMultiple from "@/componentsV2/custom/ComBranchAutocompleteMultiple.vue";
import {FormFieldRules} from "@/plugins/formFieldRules";
import axios from "axios";
import BtnTextAccept from "@/componentsV2/base/BtnTextAccept.vue";
import TooltipView from "@/components/TooltipView.vue";
import Chip from "@/componentsV2/base/Chip.vue";

export default {
  components: {
    Chip,
    TooltipView,
    BtnTextAccept,
    ComBranchAutocompleteMultiple,
    SpecAutocompleteMultiple, DialogView, NTableView
  },
  props: ['height'],
  data: () => ({
    loadState: new Stater(),
    formFieldRules: FormFieldRules,
    createState: new Stater(),
    updateState: new Stater(),
    deleteState: new Stater(),
  }),
  mounted() {
  },
  methods: {
    requestBuilder(page, onPage, sortFields) {
      return new Entity_DialogMessageTrigger()
          .selects(Entity_DialogMessageTrigger.id)
          .selects(Entity_DialogMessageTrigger.type)
          .selects(Entity_DialogMessageTrigger.sort)
          .selects(Entity_DialogMessageTrigger.name)
          .selects(Entity_DialogMessageTrigger.isSecond)
          .selects(Entity_DialogMessageTrigger.isAdult)
          .selects(Entity_DialogMessageTrigger.text)
          .selects([Entity_DialogMessageTrigger.specs, Entity_Spec.id].join('.'))
          .selects([Entity_DialogMessageTrigger.specs, Entity_Spec.name].join('.'))
          .selects([Entity_DialogMessageTrigger.comBranchs, Entity_ComBranch.id].join('.'))
          .selects([Entity_DialogMessageTrigger.comBranchs, Entity_ComBranch.name].join('.'))
          .filterAnd([Entity_DialogMessageTrigger.entity, Entity_DialogMessageTrigger.status].join('.')+' =?','active')
          .page(page)
          .onPage(onPage)
          .orderFromTable(sortFields)
          .addStateCallback(v => this.loadState.setRequestBuilderState(v))
          .addStateCallback((v) => {
            if (v.error)
              this.$store.commit('alertError', 'Ошибка загрузки данных.Если ошибка повторяется, обратитесь в тех. поддержку');
          })
    },
    create(){
      this.createState.stateLoadingUpdate();
      axios.post('/napi/dialog/messageTrigger/', this.createState.data)
        .then(() =>{
          this.createState.stateSuccess();
          this.createState.modalClose();
          this.$refs.table.load();
        })
        .catch(e =>{
          this.createState.stateError(e);
        });
    },
    update(){
      this.updateState.stateLoadingUpdate();
      axios.put('/napi/dialog/messageTrigger/'+this.updateState.data.id+'/', this.updateState.data)
          .then(() =>{
            this.updateState.stateSuccess();
            this.updateState.modalClose();
            this.$refs.table.load();
          })
          .catch(e =>{
            this.updateState.stateError(e);
          });
    },
    del(v){
      this.deleteState.stateLoadingUpdate();
      axios.put('/napi/dialog/messageTrigger/'+v.id+'/', {
        status:'deleted'
      })
          .then(() =>{
            this.deleteState.stateSuccess();
            this.updateState.modalClose();
            this.$refs.table.load();
          })
          .catch(e =>{
            this.deleteState.stateError(e);
          });
    }
  }
}
</script>
